module.exports = __webpack_public_path__ + "static/media/fish.ae210617.jpeg";